export const FILE_UPLOADER_MACHINE_ID = 'fileUploader'

export const INITIAL = 'INITIAL'
export const INITIAL_STATE = 'initial'

export const CHOOSE_FILE_CLICKED = 'CHOOSE_FILE_CLICKED'
export const CHOOSE_FILE_CLICKED_STATE = 'chooseFileClicked'

export const CANCELLED_TO_CHOOSE_FILE = 'CANCELLED_TO_CHOOSE_FILE'

export const UPLOAD_TO_AWS = 'UPLOAD_TO_AWS'
export const GO_TO_SUCCESS_STATE = 'GO_TO_SUCCESS_STATE'
export const UPLOAD_TO_AWS_STATE = 'uploadToAWS'

export const UPLOAD_TO_BACKEND = 'UPLOAD_TO_BACKEND'
export const UPLOAD_TO_BACKEND_STATE = 'uploadToBackend'

export const DELETE_FILE = 'DELETE_FILE'
export const DELETE_FILE_STATE = 'deleteFile'

export const FAILED_TO_GET_CREDENTIALS = 'FAILED_TO_GET_CREDENTIALS'

export const FAILED_TO_UPLOAD_TO_AWS = 'FAILED_TO_UPLOAD_TO_AWS'
export const FAILED_TO_UPLOAD_TO_AWS_STATE = 'failedToUploadToAWS'

export const FAILED_TO_UPLOAD_TO_BACKEND = 'FAILED_TO_UPLOAD_TO_BACKEND'
export const FAILED_TO_UPLOAD_TO_BACKEND_STATE = 'failedToUploadToBackend'

export const FAILED_TO_DELETE = 'FAILED_TO_DELETE'

export const UPLOAD_FILE_CLICKED = 'UPLOAD_FILE_CLICKED'

export const SUCCESSFULLY_UPLOADED_STATE = 'successFullyUploaded'

export const IMAGE_VALIDATION = 'IMAGE_VALIDATION'
export const IMAGE_VALIDATION_STATE = 'imageValidation'

export const PROCEED_TO_UPLOAD = 'PROCEED_TO_UPLOAD'
export const PROCEED_TO_UPLOAD_STATE = 'proceedToUpload'

export const UPDATE_S3_CLIENT_AND_CONFIG_DETAILS =
  'UPDATE_S3_CLIENT_AND_CONFIG_DETAILS'

export const RETRY_FAILED_TO_UPLOAD = 'RETRY_FAILED_TO_UPLOAD'
export const RETRY_FAILED_TO_UPLOAD_STATE = 'retryFailedToUpload'

export const DELETE_FROM_S3_BUCKET = 'DELETE_FROM_S3_BUCKET'
export const DELETE_FROM_S3_BUCKET_STATE = 'deleteFromS3Bucket'

export const ABORT_UPLOAD_TO_AWS = 'ABORT_UPLOAD_TO_AWS'
export const ABORT_UPLOAD_TO_AWS_STATE = 'abortUploadToAWSState'

export const GET_UPDATED_S3_CREDENTIALS_STATE = 'getUpdatedS3Credentials'

export const LOADING = 'LOADING'
export const FAILED = 'FAILED'
export const SUCCESS = 'SUCCESS'

export const states = {
  initial: INITIAL_STATE,
  chooseFileClicked: CHOOSE_FILE_CLICKED_STATE,
  uploadToAWS: UPLOAD_TO_AWS_STATE,
  uploadToBackend: UPLOAD_TO_BACKEND_STATE,
  deleteFile: DELETE_FILE_STATE,
  successfullyUploadedState: SUCCESSFULLY_UPLOADED_STATE,
  imageValidation: IMAGE_VALIDATION_STATE,
  proceedToUpload: PROCEED_TO_UPLOAD_STATE,
  retryFailedToUpload: RETRY_FAILED_TO_UPLOAD_STATE,
  failedToUploadToBackend: FAILED_TO_UPLOAD_TO_BACKEND_STATE,
  failedToUploadToAWS: FAILED_TO_UPLOAD_TO_AWS_STATE,
  deleteFromS3Bucket: DELETE_FROM_S3_BUCKET_STATE,
  abortUploadToAWS: ABORT_UPLOAD_TO_AWS_STATE,
  getUpdatedS3Credentials: GET_UPDATED_S3_CREDENTIALS_STATE
}
export const events = {
  initial: INITIAL,
  chooseFileClicked: CHOOSE_FILE_CLICKED,
  cancelledToChooseFile: CANCELLED_TO_CHOOSE_FILE,
  uploadToAWS: UPLOAD_TO_AWS,
  uploadToBackend: UPLOAD_TO_BACKEND,
  deleteFile: DELETE_FILE,
  failedToGetCredentials: FAILED_TO_GET_CREDENTIALS,
  failedToUploadToAWS: FAILED_TO_UPLOAD_TO_AWS,
  failedToUploadToBackend: FAILED_TO_UPLOAD_TO_BACKEND,
  failedToDelete: FAILED_TO_DELETE,
  uploadFileClicked: UPLOAD_FILE_CLICKED,
  imageValidation: IMAGE_VALIDATION,
  proceedToUpload: PROCEED_TO_UPLOAD,
  updateS3ClientAndConfigDetails: UPDATE_S3_CLIENT_AND_CONFIG_DETAILS,
  retryFailedToUpload: RETRY_FAILED_TO_UPLOAD,
  deleteFromS3Bucket: DELETE_FROM_S3_BUCKET,
  abortUploadToAWS: ABORT_UPLOAD_TO_AWS,
  gotoSuccessStep: GO_TO_SUCCESS_STATE
}
